import { theme } from "../../theme.js";

export default function Button({ onClick, title, type = "button", width = "100%", style="dark", disabled=false, icon: Icon, iconPosition = "left" }) {
    const iconStyle = iconPosition === "left" 
        ? { ...styles(theme).icon, marginRight: theme.spacing.xs }
        : { ...styles(theme).icon, marginLeft: theme.spacing.xs, marginRight: 0 };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={{ ...styles(theme)[`${style}Button`], ...(disabled ? styles(theme).disabledButton : {}), width }}
        >
            {Icon && iconPosition === "left" && <Icon style={iconStyle} />}
            {title}
            {Icon && iconPosition === "right" && <Icon style={iconStyle} />}
        </button>
    );
}

const styles = (theme) => ({
    darkButton: {
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        backgroundColor: theme.colors.light,
        color: theme.colors.textInverted,
        fontWeight: theme.fonts.weight.semibold,
        border: "none",
        borderRadius: theme.radius.md,
        cursor: "pointer",
        width: "100%",
        boxSizing: "border-box",
        height: "100%",
        minHeight: "40px",
        transition: "all 0.3s ease",
        outline: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    lightButton: {
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        backgroundColor: theme.colors.white,
        color: theme.colors.textInverted,
        border: `1px solid ${theme.colors.text}`,
        borderRadius: theme.radius.md,
        cursor: "pointer",
        width: "100%",
        boxSizing: "border-box",
        height: "100%",
        minHeight: "40px",
        transition: "all 0.3s ease",
        outline: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    cancelButton: {
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        backgroundColor: theme.colors.error,
        color: theme.colors.white,
        fontWeight: theme.fonts.weight.semibold,
        border: "none",
        borderRadius: theme.radius.md,
        cursor: "pointer",
        width: "100%",
        boxSizing: "border-box",
        height: "100%",
        minHeight: "40px",
        transition: "all 0.3s ease",
        outline: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    disabledButton: {
        backgroundColor: "#d1d5db",
        color: "#9ca3af",
        cursor: "not-allowed",
        opacity: 1,
    },
    icon: {
        width: "18px",
        height: "18px",
        marginRight: theme.spacing.xs,
        verticalAlign: "middle",
        color: "inherit",
    },
});
